import { MembershipProfile } from '@models/membership/MembershipProfile'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  selectMembershipProfileById,
  updateMembershipProfileCardNumber,
} from '@store/membership/MembershipProfileReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { App, Button, Form, Input, Space } from 'antd'
import { FC, useState } from 'react'
import { DEFAULT_SUCCESS } from '../../../App'

type Props = SBModelComponent<MembershipProfile> & {}

const CardNumberChanger: FC<Props> = ({ id, model }) => {
  const { message } = App.useApp()
  const dispatch = useAppDispatch()
  const item = model ? model : useAppSelector(selectMembershipProfileById(id!))
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isEditing, setIsEditing] = useState<boolean>(false)

  if (!item) return <></>

  if (!isEditing) {
    return item.cardNumber ? (
      item.cardNumber
    ) : (
      <Button
        onClick={() => {
          setIsEditing(true)
        }}
      >
        Add
      </Button>
    )
  }

  return (
    <Form
      className="w-full"
      layout="vertical"
      initialValues={item}
      autoComplete={'off'}
      onFinish={(values) => {
        setIsLoading(true)
        dispatch(updateMembershipProfileCardNumber(values))
          .then(() => {
            message.success(DEFAULT_SUCCESS)
            setIsEditing(false)
            //   fetchUser()
          })
          .finally(() => {
            setIsLoading(false)
          })
      }}
    >
      <Form.Item name="id" style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Space.Compact>
        <Form.Item name={'cardNumber'} noStyle className="w-full">
          <Input
            style={{ width: 110 }}
            maxLength={5}
            showCount
            disabled={isLoading}
            autoComplete={'off'}
          />
        </Form.Item>
        <Button loading={isLoading} htmlType="submit" type="primary">
          Save
        </Button>
      </Space.Compact>
    </Form>
  )
}

type CardNumberChangerType = { CardNumberChanger: typeof CardNumberChanger }
export { CardNumberChanger, type CardNumberChangerType }
